import {useEffect} from 'react';
import './TermsAndConditions.css'; // Předpokládám, že přidáš soubor CSS
import Navbar from './Navbar';

const TermsAndConditions = () => {
    useEffect(() => {
      const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      scrollToTop()
    }, [])
  return (<div>
    <Navbar />
    <div className="terms-container">
      <h1 className="terms-title">Podmínky užívání</h1>
      
      <h2 className="section-title">Úvodní ustanovení</h2>
      <ol className="section-list">
        <li className="section-item">
          <strong>Definice</strong>
          <ul>
            <li><strong>„Poskytovatel služby“</strong> označuje firmu {`${process.env.REACT_APP_URL_NAME}`}, která provozuje tento rezervační portál a umožňuje uživatelům vytvářet firemní profily.</li>
            <li><strong>„Uživatel“</strong> znamená každou osobu nebo subjekt, který se registruje na tomto portálu a využívá jeho funkcionality.</li>
            <li><strong>„Služba“</strong> označuje všechny funkcionality, které poskytovatel služby nabízí na tomto portálu, včetně tvorby firemních profilů a rezervací.</li>
            <li><strong>„Firemní profil“</strong> označuje profil vytvořený uživatelem, který obsahuje informace o jeho firmě, včetně kontaktních údajů, popisu služby a dalších relevantních informací.</li>
            <li><strong>„Rezervační formulář“</strong> označuje nástroj, který umožňuje zákazníkům firmy provádět rezervace služeb poskytovaných uživatelem.</li>
          </ul>
        </li>
        <li><strong>Popis služeb</strong><br />
          Poskytovatel služby nabízí uživatelům možnost vytvořit si firemní profil, který bude obsahovat informace o jejich firmě, produkty a služby, a rezervace pro zákazníky, kteří budou moci prostřednictvím rezervačního formuláře na profilu provádět online rezervace.
        </li>
        <li><strong>Souhlas s podmínkami</strong><br />
          Používáním služby souhlasíte s těmito podmínkami užívání. Pokud s těmito podmínkami nesouhlasíte, nemůžete službu používat.
        </li>
      </ol>

      <h2 className="section-title">Práva a povinnosti uživatelů</h2>
      <ol className="section-list">
        <li className="section-item">
          <strong>Práva uživatelů</strong>
          <ul>
            <li>Uživatel má právo na vytvoření, úpravu a správu firemního profilu.</li>
            <li>Uživatel má právo na využívání rezervačního formuláře k přijímání rezervací od zákazníků.</li>
            <li>Uživatel má právo na přístup k analytickým údajům o návštěvnosti a rezervacích na svém profilu (pokud tuto funkcionalitu poskytujete).</li>
          </ul>
        </li>
        <li className="section-item">
          <strong>Povinnosti uživatelů</strong>
          <ul>
            <li>Uživatel je povinen poskytnout pravdivé a aktuální informace při vytváření a správě firemního profilu.</li>
            <li>Uživatel je povinen udržovat svůj profil aktuální a reagovat na rezervace včas.</li>
            <li>Uživatel nesmí vkládat obsah, který porušuje platné zákony ČR, zejména obsah, který je nelegální, urážlivý nebo porušuje autorská práva třetích stran.</li>
            <li>Uživatel je odpovědný za správné nastavení a fungování rezervačního formuláře, včetně správného zpracování dat o zákaznících.</li>
          </ul>
        </li>
      </ol>

      <h2 className="section-title">Registrace a účty uživatelů</h2>
      <ol className="section-list">
        <li className="section-item">
          <strong>Vytvoření účtu</strong>
          <ul>
            <li>K používání služby je nezbytné se registrovat. Uživatel musí zadat platné kontaktní údaje, včetně e-mailové adresy a hesla.</li>
            <li>Uživatel musí být starší 18 let, aby mohl registrovat svůj firemní profil na tomto portálu.</li>
            <li>Uživatel odpovídá za všechny aktivity prováděné pod jeho účtem a musí zajistit, že přihlašovací údaje jsou uchovávány v tajnosti.</li>
          </ul>
        </li>
        <li className="section-item">
          <strong>Odpovědnost za účet</strong>
          <ul>
            <li>Uživatel je povinen informovat poskytovatele služby o jakémkoli neoprávněném přístupu k účtu nebo jeho zneužití.</li>
          </ul>
        </li>
      </ol>

      <h2 className="section-title">Používání služeb</h2>
      <ol className="section-list">
        <li className="section-item">
          <strong>Podmínky pro používání služeb</strong>
          <ul>
            <li>Službu mohou uživatelé využívat pouze pro účely prezentace jejich firmy a přijímání rezervací.</li>
            <li>Uživatelé nesmí službu využívat k nelegálním aktivitám, například k podvodům, šíření spamu nebo jinému nežádoucímu chování.</li>
          </ul>
        </li>
        <li className="section-item">
          <strong>Cenová politika</strong>
          <ul>
            <li>Služby mohou být zpoplatněny v souladu s cenovým plánem, který bude uveden na webových stránkách poskytovatele.</li>
            <li>Ceny za službu jsou uvedeny bez DPH. Poskytovatel si vyhrazuje právo měnit ceny podle potřeby.</li>
            <li>Uživatel souhlasí s tím, že bude platit za všechny služby v souladu s vybraným cenovým plánem.</li>
          </ul>
        </li>
      </ol>

      <h2 className="section-title">Omezení odpovědnosti</h2>
      <ol className="section-list">
        <li className="section-item">
          <strong>Odpovědnost poskytovatele služby</strong>
          <ul>
            <li>Poskytovatel služby nenese odpovědnost za jakékoli škody způsobené použitím služby, včetně ztráty dat, ztráty příjmů nebo jiných ztrát.</li>
            <li>Poskytovatel služby se nebude podílet na žádných sporech mezi uživateli a jejich zákazníky.</li>
          </ul>
        </li>
        <li className="section-item">
          <strong>Vymezení záruk</strong>
          <ul>
            <li>Poskytovatel služby nezaručuje, že služba bude bezchybně fungovat po celou dobu jejího používání, a neodpovídá za přerušení služby nebo technické problémy.</li>
          </ul>
        </li>
      </ol>

      <h2 className="section-title">Ochrana osobních údajů</h2>
      <ol className="section-list">
        <li className="section-item">
          <strong>Zpracování osobních údajů</strong>
          <ul>
            <li>Poskytovatel služby bude zpracovávat osobní údaje uživatele v souladu s platnou legislativou o ochraně osobních údajů, zejména s nařízením EU 2016/679 (GDPR).</li>
            <li>Poskytovatel služby bude shromažďovat osobní údaje uživatele, které jsou nezbytné pro registraci a poskytování služeb (např. jméno, e-mailová adresa, telefonní číslo).</li>
          </ul>
        </li>
        <li className="section-item">
          <strong>Používání cookies</strong>
          <ul>
            <li>Tento portál používá cookies pro zlepšení uživatelského zážitku. Uživatel souhlasí s používáním cookies při návštěvě webových stránek.</li>
          </ul>
        </li>
      </ol>

      <h2 className="section-title">Autorská práva a duševní vlastnictví</h2>
      <ol className="section-list">
        <li className="section-item">
          <strong>Vlastnictví obsahu</strong>
          <ul>
            <li>Všechny materiály a obsah na webových stránkách poskytovatele služby (včetně grafiky, šablon a software) jsou chráněny autorskými právy a patří poskytovateli služby.</li>
            <li>Uživatelé mají právo na používání šablon a obsahu pouze pro účely vytvoření a správy svého firemního profilu.</li>
          </ul>
        </li>
      </ol>
    </div>
    </div>
  );
};

export default TermsAndConditions;